<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-mini-program`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm0 3.818C13.959 5.818 5.818 13.958 5.818 24c0 10.041 8.14 18.182 18.182 18.182 10.041 0 18.182-8.14 18.182-18.182 0-10.041-8.14-18.182-18.182-18.182zM35.883 19.45c-.04-3.71-3.069-6.737-6.778-6.778a6.624 6.624 0 00-6.718 6.718l.053 4.747.015-.001.05 4.489-.004.165a2.622 2.622 0 01-2.67 2.509 2.876 2.876 0 01-2.823-2.822 2.624 2.624 0 012.674-2.674l.044-4-.233.002a6.623 6.623 0 00-6.484 6.716c.04 3.71 3.068 6.737 6.777 6.777a6.624 6.624 0 006.718-6.717l-.052-4.748h-.016l-.049-4.487.003-.166a2.622 2.622 0 012.671-2.508 2.876 2.876 0 012.822 2.822 2.624 2.624 0 01-2.674 2.674l-.044 4 .233-.002a6.623 6.623 0 006.485-6.716z"/></svg>
</template>
<script>

export default {
  name: 'IconMiniProgram',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
